import React, {Component} from 'react';
import {FilePond, registerPlugin} from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import {urlConfig} from "../config";
// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

export default class ThumbnailUploader extends Component {

    constructor(props) {
        super(props);



        this.state = {
            files: props.files,
            type: props.type,
            inputName:props.inputName,
            label: props.label
        };



        let self = this;
        this.serverConfig =
            {
                url: `${urlConfig.momentsServiceUrl}/${this.state.type}/uploadThumbnails`,
                process: {
                    method: 'POST',
                    timeout: 600000,
                    onload: (response) => {
                        if (response) {
                            response = JSON.parse(response);
                            if (response && (response.responseType === "SUCCESS") && response.entity) {
                                let url = response.entity;
                                console.log("uploaded");
                                console.log({url});
                                self.props.updateThumbnails(url);
                            }
                        }

                    },
                    onerror: null
                }
            }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.files !== this.state.files) {
            this.setState({files: nextProps.files})
        }
    }


    handleInit = () => {

    };

    render() {


        const uploaderStyle={
            // marginTop: '1em'
        };

        return (<FilePond ref={ref => this.pond = ref} style={uploaderStyle}
                          name={this.state.inputName}
                          allowMultiple={false}
                          maxFiles={1}
                          allowFileTypeValidation={false}
                          maxFileSize={'50MB'}
                          allowFileSizeValidation={true}
                          acceptedFileTypes={['.jpeg,.jpg']}
                          server={this.serverConfig}
                          oninit={() => this.handleInit()}
                          labelIdle={this.state.label}
                          allowRevert={false}
                          allowReplace={false}
                          allowBrowse={true}
                          allowDrop={true}
                          allowPaste={true}
        >


        </FilePond>)
    }
}
